import { faEyeSlash } from '@fortawesome/pro-regular-svg-icons'

import { EmptyState, FormattedMessage } from '@b-stock/fe-core/bstock-react'

const ns = 'Listing.errors.visibilityWindow'

export const ListingVisibilityWindowErrorBanner = () => {
  return (
    <EmptyState
      icon={faEyeSlash}
      title={<FormattedMessage id={`${ns}.title`} />}
      description={<FormattedMessage id={`${ns}.description`} />}
      size={4}
    />
  )
}
